import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function BA_Mobile_view_faq_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='pb-4'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-6'>Which business analytics tools or systems have you worked with?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          With this question, a hiring manager is making an attempt to make sure you recognize what a enterprise analyst does, specially in case you haven’t held the placement earlier than. Additionally they need to understand the way you’d approach the activity, to make certain it suits with the organization’s desires and their vision for the role. To prepare for this query, review the placement description in the process ad, and craft an answer that spotlights the duties and duties listed within the advert.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>When you are given a new project, what do you do first?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          With this question, the hiring supervisor is first and essential assessing your experience with project control, because it’s typically an important facet of a business analyst’s task. There’s no unmarried proper solution. The nice way to respond is to in reality speak your task control fashion, such as the unique phases and the sorts of deliverables you might create. Offering examples of times while you’ve modified your methods to higher suit a selected assignment can reveal your flexibility to the hiring manager.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>How do you handle changes to requirements?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          This situational question, like the one above, is meant to gauge your work style, particularly your approach to changing situations. It’s also a good way for the hiring manager to assess your logic and critical-thinking skills.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
